import Request from './request';

async function getOauthUrl() {
    return Request('get', "api/chanjet/getOauthUrl");
}

async function bindChanjet(data) {
    return Request('post', "api/chanjet/bindChanjet", data);
}

export default {
    getOauthUrl,
    bindChanjet,
}
